
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wideformatprintercosts/privacy-policy",
      function () {
        return require("private-next-pages/wideformatprintercosts/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wideformatprintercosts/privacy-policy"])
      });
    }
  